import { render, staticRenderFns } from "./IndexListItem.vue?vue&type=template&id=5c891bcb"
import script from "./IndexListItem.vue?vue&type=script&lang=js"
export * from "./IndexListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports